import { Injectable, Injector } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/finally'
import { AuthService } from './auth.service'
import { TokenModel } from './main/authentication/models/token.model'

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  authService: any

  static addToken(req: HttpRequest<any>, token: TokenModel): HttpRequest<any> {
    return req.clone({
      setHeaders: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token.access_token,
      },
    })
  }

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any> | any> {
    if (!request.url.includes('/oauth/v2/token')) {
      this.authService = this.injector.get(AuthService)
      return next
        .handle(TokenInterceptorService.addToken(request, AuthService.getToken()))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            return this.authService
              .refreshToken()
              .catch((errorz: HttpErrorResponse) => {
                if (error instanceof HttpErrorResponse) {
                  switch (errorz.status) {
                    case 400:
                    case 401:
                      this.authService.goToLock()
                  }
                } else {
                  return Observable.throw(error)
                }
              })
              .switchMap(token => {
                return next.handle(TokenInterceptorService.addToken(request, AuthService.getToken()))
              })
          }
          return Observable.throw(error)
        })
    } else {
      return next.handle(request)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/token-interceptor.service.ts